import { render, staticRenderFns } from "./IpIndex.vue?vue&type=template&id=35c1cf38&"
import script from "./IpIndex.vue?vue&type=script&lang=js&"
export * from "./IpIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports